import { useIsCached } from '@va/util/hooks';
import { useMemo } from 'react';
import { Key } from 'swr';

/** @deprecated */
export const useShouldFetchConditionally = (key: Key, shouldFetch: boolean) => {
  const isCached = useIsCached(key);
  const shouldFetchConditionally = useMemo(() => {
    if (isCached) return false;
    if (shouldFetch) return false;
    return true;
  }, [isCached, shouldFetch]);
  return { shouldFetchConditionally, key, isCached };
};
